import { h} from 'preact';
import { useState } from 'preact/hooks';
import { Text, MarkupText } from 'preact-i18n';
import Markup from 'preact-markup';
import Carousel from 'preact-flickity-component'
import '../../../node_modules/flickity/dist/flickity.css'
import HtmlToText from 'html-to-text';
import { GetSafeImageUrl } from '../../utils/ApiUtil';

export const OneVideo = props => {
  const [videoBlock, setVideoBlock] = useState(props.videoBlock);
  let maxLength = 80;
  let height = 110;
  let width = videoBlock.thumbnail ? Math.round(height * videoBlock.thumbnail.width / videoBlock.thumbnail.height) : 0;
  if(width < 190) {
    width = 190;
    height = videoBlock.thumbnail ? Math.round(width * videoBlock.thumbnail.height / videoBlock.thumbnail.width) : 0;
  }
  let title = (videoBlock.name) ? HtmlToText.htmlToText(videoBlock.name) : "";
  let description = (videoBlock.description) ? HtmlToText.htmlToText(videoBlock.description) : "";
  // let trimmedDescription = (description.length > (maxLength+3)) ? description.substr(0, maxLength) + "..." : description;
  return (
    <a href={videoBlock.contentUrl}>
      <div className="ae-border-box-np video-block">
        <div className="result-video">
          <div className="block-img">
              <img src={GetSafeImageUrl(videoBlock.thumbnailUrl + "&h=" + height + "&w=" + width)} height={height} width={width} title={description} alt={description} />
          </div>
        </div>
        <div className="video-description">
          <Markup markup={title} type="html" trim={false} className="ae-line-clamp-3"/>
        </div>
      </div>
    </a>
  )
}
export const OneVideoSnippets = props => {
  const [videoBlock, setVideoBlock] = useState(props.videoBlock);
  let height = 110;
  let width = videoBlock.thumbnailUrl && videoBlock.thumbnail ? Math.round(height * videoBlock.thumbnail.width / videoBlock.thumbnail.height) : 0;
  let videoSnippetClass = props.snippetType === "small" ? "ae-border-box video-snippet-sm" : "ae-border-box video-snippet";

  return (
    <a href={videoBlock.contentUrl} target="_blank" className="ae-dark video-snippet-a">
      <div className={videoSnippetClass}>
        <div className="video-snippet-left">
            <div>
              {videoBlock.thumbnailUrl ? 
                (<img src={GetSafeImageUrl(videoBlock.thumbnailUrl + "&h=" + height + "&w=" + width)} height={height} width={width} />)
                : ({})}
          </div>
        </div>
        <div className="video-snippet-right">
          <div>
            <div className="ae-subtitle-large ae-blue-text ae-line-clamp-2 video-title"><Markup markup={videoBlock.name} type="html" trim={false}/></div>
            <div className="ae-para result-snippet">
              {videoBlock.description ? <Markup markup={videoBlock.description} className="ae-line-clamp-2"/> : ""}
              <span className="ae-blue-text">{videoBlock.publisher && videoBlock.publisher.length > 0 ? (videoBlock.publisher[0].name + " ") : ""}</span>
              <span className="ae-blue-text">{videoBlock.viewCount ? (videoBlock.viewCount.toLocaleString() + " Views") : ""}</span>
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}
export const Video = props =>  {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);
  if(!item || !item.value || !item.value.id || item.answerType !== "Videos") {
    return (""); //defensive check
  }
  var id = item.value.id;
  var videoBlocks = (searchResp.videos && searchResp.videos.id === item.value.id) ? searchResp.videos.value : null;
  if(videoBlocks === null) {
    return (""); //defensive check
  }
  return (
    <div className="result-block">
      <div className="ae-title result-title"><Text id="newSearch.videos">Videos</Text></div>
      <div className="result-videos">
        {videoBlocks.map(videoBlock => {
          return <OneVideo videoBlock={videoBlock} />
        })}
      </div>
    </div>
  )
}
export const VideoCarousel = props =>  {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);
  const [affid, setAffid] = useState(props.affid);
  if(!item || !item.value || !item.value.id || item.answerType !== "Videos") {
    return (""); //defensive check
  }
  var id = item.value.id;
  var videoBlocks = (searchResp.videos && searchResp.videos.id === item.value.id) ? searchResp.videos.value : null;
  if(videoBlocks === null) {
    return (""); //defensive check
  }
  return (
    <div className="result-block">
      <div className="ae-title result-title"><Text id="newSearch.videos">Videos</Text></div>
      <div className="ae-caption see-more-link">
        <a href={`/search?q=${encodeURIComponent(query)}&service=videos&affid=${encodeURIComponent(affid)}`}><Text id="newSearch.seeMoreVideos">See more videos</Text></a>
      </div>
      <Carousel options={{wrapAround: false, pageDots: false, percentPosition: false, cellAlign: props.isRightToLeft ? 'right' : 'left', rightToLeft: props.isRightToLeft}}>
        {videoBlocks.map(videoBlock => {
          return <OneVideo videoBlock={videoBlock} />
        })}
      </Carousel>
     
    </div>
  )
}
